
import { NavBar } from "@/components/NavBar";
import FCMTokenDisplay from "@/components/notifications/FCMTokenDisplay";
import PermissionAlert from "@/components/notifications/PermissionAlert";
import NotificationsList from "@/components/notifications/NotificationsList";
import Header from "@/components/notifications/Header";
import { useNotificationSystem } from "@/hooks/useNotificationSystem";

export default function Index() {
  const { 
    fcmToken,
    isLoading,
    permissionDenied,
    notifications,
    markAsRead,
    deleteNotification,
    refreshToken,
    requestPermissionAgain
  } = useNotificationSystem();

  return (
    <div className="min-h-screen bg-background">
      <NavBar />
      <main className="container mx-auto p-4">
        <Header notificationsEnabled={!permissionDenied} />
        <div className="grid gap-8">
          {permissionDenied && (
            <PermissionAlert onRequestPermission={requestPermissionAgain} />
          )}
          <FCMTokenDisplay 
            fcmToken={fcmToken}
            isLoading={isLoading}
            onRefreshToken={refreshToken}
          />
          <NotificationsList 
            notifications={notifications}
            onMarkAsRead={markAsRead}
            onDelete={deleteNotification}
          />
        </div>
      </main>
    </div>
  );
}
